const lastTouchChoices = [
  {
    name: 'today',
    days: 0,
  },
  {
    name: 'yesterday',
    days: 1,
  },
  {
    name: 'last week',
    days: 7,
  },
  {
    name: 'last month',
    days: 30,
  },
  {
    name: 'last year',
    days: 365,
  }
]

export default lastTouchChoices



// WEBPACK FOOTER //
// ./src/views/misc/lastTouchChoices.js